// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const el_banner_prefix = /** @type {(inputs: {}) => string} */ () => {
	return `Ο επίσημος συνεργάτης της`
};

/** @type {(inputs: {}) => string} */
const en_banner_prefix = () => 'banner_prefix'

/** @type {(inputs: {}) => string} */
const ru_banner_prefix = en_banner_prefix;

/** @type {(inputs: {}) => string} */
const he_banner_prefix = en_banner_prefix;

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const banner_prefix = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.banner_prefix(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("banner_prefix", locale)
	if (locale === "en") return en_banner_prefix(inputs)
	if (locale === "el") return el_banner_prefix(inputs)
	if (locale === "ru") return ru_banner_prefix(inputs)
	if (locale === "he") return he_banner_prefix(inputs)
	return "banner_prefix"
};